<template>
    <li class="flex hover:cursor-pointer hover:bg-primary/[.12] hover:text-primary">
        <router-link :to="location.to" class="w-full p-2">
            <span class="flex items-center">
                <icon>{{ location.icon }}</icon>
                <span>
                    <p class="ml-3 text-sm font-normal text-gray-900">{{ location.label }}</p>
                    <p class="ml-3 text-sm font-normal text-gray-500" v-if="location.subtype">{{ location.subtype }}</p>
                </span>
            </span>
        </router-link>
    </li>
</template>

<script setup lang="ts">
import Icon from '@/components/Icon.vue';
import { LocationSearchResult } from '../location';

defineProps<{ location: LocationSearchResult }>();
</script>
